module.exports = __webpack_public_path__ + "img/2-7.da2049e4.png";